import { Box, Stack, PageBlock } from 'braid-design-system';
import { renderRoutes } from 'react-router-config';

// @ts-expect-error: non-ts file
import { provideHooks } from 'redial';
import type { RedialLocals } from 'src/types/RedialLocals';
import type { TSeekExperiments } from 'src/store/experiments/experimentHelpers';
import { useSelector } from 'src/store/react';
import { getCounts, updateCriteria } from 'src/store/search/search';
import { selectIsFiltersExpanded } from 'src/store/selectors';
import SearchBar from './SearchBar/SearchBar';
import RefineBar from './RefineBar/RefineBar';
import * as styles from './Search.css';

const hooks = {
  first({ dispatch, path = '', query, zone }: RedialLocals) {
    return dispatch(
      updateCriteria({
        path,
        query,
        zone,
      }),
    );
  },
  defer({ dispatch, country, path = '', query, cookies, zone }: RedialLocals) {
    return dispatch(
      getCounts({
        zone,
        country,
        path,
        query,
        cookies,
      }),
    );
  },
};

export interface SearchProps {
  route: Record<string, any>;
  experiments?: TSeekExperiments;
}

const Search = ({ route }: SearchProps) => {
  const filtersExpanded = useSelector(selectIsFiltersExpanded);

  return (
    <Box height="full">
      <Box
        position="relative"
        // This is to ensure this will not cover Header's language switcher
        zIndex={2}
        background="brand"
        paddingTop={{
          mobile: 'medium',
          tablet: 'large',
        }}
        paddingBottom={{
          mobile: 'medium',
          tablet: 'small',
        }}
        className={styles.branding}
      >
        <PageBlock width="medium">
          <Stack
            space={{
              mobile: filtersExpanded ? 'xsmall' : 'none',
              tablet: 'xsmall',
            }}
          >
            <SearchBar collapsed={filtersExpanded} />
            <RefineBar expanded={filtersExpanded} />
          </Stack>
        </PageBlock>
      </Box>
      {renderRoutes(route.routes)}
    </Box>
  );
};

export default provideHooks(hooks)(Search);
